import Resource from "./resource";
import {appContainer} from "../contexts/app";
import {List} from "immutable";
import {orderById} from "../lib";
import pluralize from "pluralize";

export default function FacilityRecordFactory(service) {
  const FacilityRecord = Resource(
    service,
    {
      account_id: "",
      name: "",
      short_name: "",
      address: "",
      geo: {},
      buildings_order: []
    },
    {
      /*
       Load all of a facilities "dependencies" that may be needed
       when editing. Unfortunately, this really has to be a waterfall
       because of how things are related. (The server doesn't do
       any population of related fields right now...
       but it could and would probably handle this better)
       This is a good case for a fastJoin hook on the server.

       Note that all of these records' methods actually load
       their response into state, so we don't really need to
       do anyting with the response, we are just rehydrating
       state to ensure it is up to date.
       */
      async load() {
        /*
         MarkerTypes and MarkerTypeCats can be fetched async
         bc they are not realy related to anything. Batch
         those two with the first call for facility. We
         also already know the facility_id, so we can
         batch the call to floors too.
         */
        const MarkerTypeRecord = appContainer.MarkerTypeRecord;
        const MarkerTypeCategoryRecord = appContainer.MarkerTypeCategoryRecord;
        const BuildingRecord = appContainer.BuildingRecord;
        const FloorRecord = appContainer.FloorRecord;
        const MarkerRecord = appContainer.MarkerRecord;

        const batched = await Promise.all([
          MarkerTypeRecord.find(),
          MarkerTypeCategoryRecord.find(),
          this.fetch(),
          BuildingRecord.find({
            query: {
              facility_id: this._id
            }
          })
        ]);
        const markerTypes = batched[0];
        const markerTypeCategories = batched[1];
        const facility = batched[2];
        const buildings = batched[3];

        const floors = await FloorRecord.find({
          query: {
            building_id: {$in: buildings.data.toList().map(b => b._id)}
          }
        });
        const markers = await MarkerRecord.find({
          query: {
            floor_id: {$in: floors.data.toList().map(b => b._id)}
          }
        });

        // Everything is loaded into state...not sure if I
        // even should return anything here because that may
        // be misleading in how this func should be used.
        return {
          facility,
          buildings,
          floors,
          markers,
          markerTypes,
          markerTypeCategories
        };
      },

      buildings() {
        const buildings = appContainer.state.get("buildings");
        if (!buildings) {
          // Immutable returns undefined if no values at key
          return List();
        }

        const filtered = buildings
          .toList()
          // filter by current building
          // Filter the buildings by those in the buildings_order array
          .filter(function(building) {
            return building => building.facility_id === this._id && this.indexOf(building._id) >= 0;
          }, this.buildings_order);
        // Sort the infographics in order
        return orderById(filtered, this.buildings_order);
      },

      getPath() {
        return `${this._id}`;
      },

      getNewChildPath() {
        return `${this.getPath()}/${pluralize(appContainer.BuildingRecord.getTypeName(), 2)}`;
      },

      getTypeName() {
        return FacilityRecord.getTypeName();
      },

      getResource() {
        return FacilityRecord;
      }
    }
  );

  FacilityRecord.getTypeName = function() {
    return "facility";
  };

  return FacilityRecord;
}



// WEBPACK FOOTER //
// ./src/feathers/facility-record.js